import type { LookupItem } from '../../../mocks/criminalMasterData';
import { isOtherLookup } from '../criminal/criminalConstants';
import { courtTypeQueryParam } from '../../../utils/courtTypeLookup';
import { isCivilLitigationOriginalCourtsCategory } from '../../../utils/configureAssignmentFields';

export { isCivilLitigationOriginalCourtsCategory };
export const CIVIL_LITIGATION_CA_SUB_CODE = 'CA';

function isCaSubCategoryName(name: string): boolean {
  const n = name.trim();
  if (!n) return false;
  if (/^CA\s*[-–]/i.test(n)) return true;
  return n.toLowerCase().includes('actions against the state');
}

/** Default "Has action been instituted?" when a sub file category is selected. */
export function defaultHasActionInstitutedForSubCategory(
  subFileCategoryId: string,
  subCategories: LookupItem[] = [],
  subFileCategoryName?: string,
): 'yes' | 'no' {
  return isCaActionsAgainstStateSubCategory(subFileCategoryId, subCategories, subFileCategoryName)
    ? 'yes'
    : 'no';
}

/** Court Type is mandatory for the CA sub file category regardless of action instituted. */
export function isCaActionsAgainstStateSubCategory(
  subFileCategoryId: string,
  subCategories: LookupItem[] = [],
  subFileCategoryName?: string,
): boolean {
  const id = subFileCategoryId.trim();
  if (id) {
    const row = subCategories.find((s) => s.id === id);
    const code = row?.code?.trim().toUpperCase() ?? '';
    if (code === CIVIL_LITIGATION_CA_SUB_CODE) return true;
    if (isCaSubCategoryName(row?.name ?? '')) return true;
  }
  return isCaSubCategoryName(subFileCategoryName ?? '');
}

export function requiresCourtType(
  hasActionInstituted: string,
  subFileCategoryId: string,
  subCategories: LookupItem[] = [],
  subFileCategoryName?: string,
): boolean {
  return (
    hasActionInstituted === 'yes' ||
    isCaActionsAgainstStateSubCategory(subFileCategoryId, subCategories, subFileCategoryName)
  );
}

export { courtTypeQueryParam };

export function isHighUrgencyLevel(name: string): boolean {
  return name.trim().toLowerCase().includes('high');
}

export function isOtherNextStep(name: string, codeOrId?: string): boolean {
  return isOtherLookup(name, codeOrId);
}

export function isOtherCorporateInstitute(
  id: string,
  name?: string,
  code?: string,
): boolean {
  if (code?.trim().toUpperCase() === 'OTHER') return true;
  if (id.trim().toLowerCase() === 'other') return true;
  return (name ?? '').trim().toLowerCase() === 'other';
}
